<div
  #chartContainer
  data-testid="bar-chart-container"
  [class]="className"
  [style.height]="height"
  [style.width]="width"
></div>
